module.exports = __webpack_public_path__ + "static/synchronized_flow_no_autosale-be84955ce057cb667834a59429647bf1.png";